import { render, staticRenderFns } from "./ExchangeInsurance.vue?vue&type=template&id=275de7fc&"
import script from "./ExchangeInsurance.vue?vue&type=script&lang=ts&"
export * from "./ExchangeInsurance.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports